<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div style="margin-left: -2rem;margin-right: -2rem;">
        <b-breadcrumb :items="items" v-if="thai_student==1" />
        <b-breadcrumb :items="items_eng" v-if="thai_student==0" />
      </div>
      <create-bio></create-bio>
      <create-post_63></create-post_63>
    </div>
  </div>
</template>

<script>
import CreatePost_63 from "../../components/CreatePost_63.vue";
import CreateBio from "../../components/CreateBio.vue";

export default {
  components: {
    CreatePost_63,
    CreateBio
  },
  name: "Post",
  data() {
    return {
      items: [
        {
          text: "หน้าหลัก",
          href: "#/Dashboard_63"
        },
        {
          text: "ยืนยันการติดต่อขอรับปริญญา",
          href: "#"
        }
      ],
      items_eng: [
        {
          text: "Home",
          href: "#/Dashboard_63"
        },
        {
          text: "The way to obtain Certificate<",
          href: "#"
        }
      ],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {
    this.thai_student = this.$store.state.user.thaistudent;
  }
};
</script>
<style></style>
